import { usePWAContext } from "./PWAProvider";
import { MdWifiOff, MdWifi } from "react-icons/md";
import { useState, useEffect, useCallback, useRef } from "react";

const OfflineBanner = () => {
  const { isOnline } = usePWAContext();
  const [show, setShow] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);
  const prevOnline = useRef(isOnline);

  const handleOnlineStatusChange = useCallback(() => {
    if (!isOnline) {
      setShow(true);
      setWasOffline(true);
    } else if (wasOffline) {
      // Show "back online" briefly
      setShow(true);
      const timer = setTimeout(() => setShow(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isOnline, wasOffline]);

  useEffect(() => {
    handleOnlineStatusChange();
    prevOnline.current = isOnline;
  }, [handleOnlineStatusChange, isOnline]);

  if (!show) return null;

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-50 flex items-center justify-center gap-2 py-2 text-sm font-medium transition-all ${
        isOnline
          ? "bg-green-500 text-white"
          : "bg-red-500 text-white"
      }`}
    >
      {isOnline ? (
        <>
          <MdWifi size={18} />
          Back online
        </>
      ) : (
        <>
          <MdWifiOff size={18} />
          You are offline — showing cached data
        </>
      )}
    </div>
  );
};

export default OfflineBanner;